// extracted by mini-css-extract-plugin
export default {"body":"ChangeLanguage_body__bf+5P","button":"ChangeLanguage_button__Lxdbz"};